import {translate} from '@docusaurus/Translate';
export const ASSISTANT_CONSENT_STORAGE_KEY = 'folderspan.ai-docs-assistant.consent.v1';
export const ASSISTANT_CONSENT_VERSION = 2;

export type AssistantConsentRecord = {
  version: number;
  acceptedAt: string;
};

export const assistantConsentHighlights = [
  translate({message: '无需登录即可提问；已登录时可能关联用户 UUID，未登录时使用来源 IP 做隔离和安全控制。'}),
  translate({message: '问题（包括主动引用的页面内容）、页面标题和路径会发送至问答服务，并可能由配置的模型和内容安全服务处理。'}),
  translate({message: '本地历史最多保存 20 个会话；清除本地记录不会同步删除服务端记录。'}),
];

function isConsentRecord(value: unknown): value is AssistantConsentRecord {
  return (
    typeof value === 'object' &&
    value !== null &&
    !Array.isArray(value) &&
    (value as AssistantConsentRecord).version === ASSISTANT_CONSENT_VERSION &&
    typeof (value as AssistantConsentRecord).acceptedAt === 'string' &&
    (value as AssistantConsentRecord).acceptedAt.length > 0
  );
}

export function readAssistantConsent(): boolean {
  try {
    const storedValue = window.localStorage.getItem(ASSISTANT_CONSENT_STORAGE_KEY);
    if (!storedValue) {
      return false;
    }

    return isConsentRecord(JSON.parse(storedValue) as unknown);
  } catch {
    return false;
  }
}

export function writeAssistantConsent(): boolean {
  try {
    const record: AssistantConsentRecord = {
      version: ASSISTANT_CONSENT_VERSION,
      acceptedAt: new Date().toISOString(),
    };
    window.localStorage.setItem(ASSISTANT_CONSENT_STORAGE_KEY, JSON.stringify(record));
    return true;
  } catch {
    return false;
  }
}
